import Loader from '../../components/Common/Loader';

interface SubmitButtonProps {
  title?: string;
  loader?: boolean;
  size?: string;
  marginTop?: string;
  cancelOperation?: null | ((value: boolean) => void);
  disable?: boolean;
  type?: string;
  disabled?: boolean;
}

const SubmitButton = ({
                        title,
                        loader,
                        size = 'w-full',
                        marginTop = 'mt-10',
                        cancelOperation = null,
                        disable = false
                      }: SubmitButtonProps) => {
  return (
    <div className="flex gap-3 flex-wrap md:flex-nowrap">
      {cancelOperation && (
        <button
          type="button"
          className={`${size} mt-2 md:${marginTop} flex justify-center bg-storyblueSecondLightText text-white hover:text-white font-bold rounded-2xl px-4 py-2 text-sm`}
          onClick={() => cancelOperation(false)}
        >
          Close
        </button>
      )}
      <button
        type="submit"
        className={`${
          disable ? 'opacity-50' : ''
        }  ${size} mt-2 md:${marginTop} flex justify-center gap-2 bg-storyblue text-white font-bold rounded-2xl px-4 py-2 text-sm items-center`}
        disabled={loader || disable}
      >
        {title}
        <Loader loader={loader} />
      </button>
    </div>
  );
};

export default SubmitButton;
